import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
// import { usePermisos } from '../../../context/PermisosContext';
import { getApiUrl } from '../../../utils/apiConfig';


const ZonaDropDown = ({ poblacionSeleccionada, selectedObra, setSelectedObra, ubicacionesPermitidas, disabled, isAdmin }) => {
  const [zonaOptions, setZonaOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  //  const { ubicacionesPermitidas } = usePermisos();
  // console.log('Ubicaciones permitidas 2:', ubicacionesPermitidas);
  
  // 🔒 Bloquear para admin si ya tiene un valor
  const shouldDisable = disabled || (isAdmin && selectedObra?.Subdivision);

  useEffect(() => {
    // console.log('ZonaDropDown useEffect poblacionSeleccionada:', poblacionSeleccionada);
    if (!poblacionSeleccionada) {
      setZonaOptions([]);
      return;
    }
    // Normalizar población: quitar espacios y poner mayúsculas
    const poblacionNormalizada = poblacionSeleccionada.trim().toUpperCase();
    const fetchZonas = async () => {
      try {
        // Si hay ubicacionesPermitidas, agregarlas como parámetro
        let url = `${getApiUrl('/api/zonas')}?poblacion=${encodeURIComponent(poblacionNormalizada)}`;
        if (ubicacionesPermitidas && ubicacionesPermitidas.length > 0) {
          url += `&ubicacionesPermitidas=${encodeURIComponent(ubicacionesPermitidas.join(','))}`;
        }
        const res = await fetch(url);
        // console.log('url zonas', url, res);
        const data = await res.json();
        // Extraer subdivisiones únicas
        // Mapear subdivisiones y asociar el IdUbicacion correspondiente
        const opciones = data
          .filter(item => item.Subdivision)
          .map((item, idx) => ({
            value: item.Subdivision.trim(),
            label: item.Subdivision.trim(),
            color: '#eee',
            id: item.Subdivision.trim() + idx, // para key única
            idUbicacion: item.IdUbicacion // <-- importante para el backend
          }));
        setZonaOptions(opciones);
      } catch (error) {
        console.error('Error al obtener las zonas:', error);
      }
    };
    fetchZonas();
  }, [poblacionSeleccionada]);

  const selected = {
    value: selectedObra?.Subdivision || '',
    label: selectedObra?.Subdivision || '',
    color: '#eee'
  };

  const placeholder = 'Selecciona zona';
  const hasSelection = Boolean((selectedObra?.Subdivision || '').trim());


  // Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);


  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 text-xs font-medium text-gray-700 truncate">Zona*</label>
      <button
        disabled={shouldDisable}
        onClick={() => !shouldDisable && setIsOpen(!isOpen)}
        title={isAdmin && selectedObra?.Subdivision ? 'Campo bloqueado para administradores' : (hasSelection ? selected.label : placeholder)}
        className={`DropDownName w-full p-2 shadow-sm border rounded bg-white flex justify-between items-center ${
          shouldDisable ? 'opacity-60 cursor-not-allowed' : ''
        }`}
      >
        <span className={`truncate ${hasSelection ? '' : 'text-gray-400'}`}>
          {hasSelection ? selected.label : placeholder}
        </span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        // <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto">
        //   {zonaOptions.map(option => (
        //     <li
        //       key={option.id}
        //       onClick={() => {
        //         setSelectedObra({ ...selectedObra, Subdivision: option.value, IdUbicacion: option.idUbicacion });
        //         setIsOpen(false);
        //       }}
        //       className={classNames('cursor-pointer px-4 py-2 text-sm', {
        //         'bg-gray-100': (selectedObra.Subdivision?.trim() || '') === option.value,
        //       })}
        //       style={{
        //         backgroundColor:
        //           (selectedObra.Subdivision?.trim() || '') === option.value ? '#f3f4f6' : 'white',
        //       }}
        //       onMouseEnter={e => (e.currentTarget.style.backgroundColor = option.color)}
        //       onMouseLeave={e => (e.currentTarget.style.backgroundColor = (selectedObra.Subdivision?.trim() || '') === option.value ? '#f3f4f6' : 'white')}
        //     >
        //       {option.label}
        //     </li>
        //   ))}
        // </ul>

        <ul className="absolute z-10 mt-1 w-full bg-white border rounded shadow-lg max-h-60 overflow-auto" role="listbox">
          <li
            onClick={() => { setSelectedObra({ ...selectedObra, Subdivision: '', IdUbicacion: '' }); setIsOpen(false); }}
            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors ${!hasSelection ? 'bg-blue-50 text-blue-700 font-medium' : ''}`}
            role="option"
            aria-selected={!hasSelection}
          >
            {placeholder}
          </li>
          {zonaOptions.map(option => (
            <li
              key={option.value}
              onClick={() => {
                setSelectedObra({ ...selectedObra, Subdivision: option.value, IdUbicacion: option.idUbicacion });
                setIsOpen(false);
              }}
              className={classNames(
                'cursor-pointer px-4 py-2 text-sm hover:bg-blue-50 hover:text-blue-700 transition-colors',
                { 'bg-blue-50 text-blue-700 font-medium': (selectedObra.Subdivision?.trim() || '') === option.value }
              )}
              role="option"
              aria-selected={(selectedObra.Subdivision?.trim() || '') === option.value}
            >
              {option.label}
            </li>
          ))}
        </ul>

      )}
    </div>
  );
};

export default ZonaDropDown;
